"use client";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Img from "./assets/image.png";
import img1 from "./assets/img2.png";
 
import Breadcrumb from "./Breadcrumb";
import Header from "../Header";
import { FiEdit2, FiPlus, FiMinus } from "react-icons/fi";
import Footer from "../Footer";
import Subscription from "./Subscription";
import { useProfile } from "../../context/ProfileContext";

const Cartpage = () => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  // ✅ State for cart items// OTP Modal States
const [showModal, setShowModal] = useState(false);
const [isVerified, setIsVerified] = useState(false);
const [otp, setOtp] = useState(Array(6).fill(""));
const [modalType, setModalType] = useState(""); // "email" or "phone"
const [email, setEmail] = useState("");
const [mobile, setMobile] = useState("");
const [countryCode, setCountryCode] = useState("+91");

const { verifyEmailOtp, verifyMobileOtp } = useProfile();

  const [cartItems, setCartItems] = useState([
    {
      id: 1,
      name: "Loveable for someone Teddy Bear",
      price: 50,
      quantity: 1,
      img: "https://cdn.acsdev.in/Rentastic/image.png",
    },
    {
      id: 2,
      name: "Loveable for someone Teddy Bear",
      price: 50,
      quantity: 1,
      img: "https://cdn.acsdev.in/Rentastic/img2.png",
    },
  ]);
 
  // ✅ Increase quantity
  const increaseQty = (id) => {
    setCartItems((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, quantity: item.quantity + 1 } : item
      )
    );
  };
 
  // ✅ Decrease quantity
  const decreaseQty = (id) => {
    setCartItems((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, quantity: item.quantity > 1 ? item.quantity - 1 : 1 }
          : item
      )
    );
  };
   
// OTP Input Change Handler
const handleOtpChange = (val, idx) => {
  if (/^[0-9]?$/.test(val)) {
    const newOtp = [...otp];
    newOtp[idx] = val;
    setOtp(newOtp);
  }
};


// OTP Submit
const handleConfirmCode = async () => {
  const otpCode = otp.join("");
  if (otpCode.length !== 6) return alert("Enter all 6 digits");

  let res;
  if (modalType === "email") {
    res = await verifyEmailOtp({ email, otp: otpCode });
  } else if (modalType === "phone") {
    res = await verifyMobileOtp({ mobile: `${countryCode} ${mobile}`, otp: otpCode });
  }

  if (res?.status === 200) {
    setIsVerified(true); // ✅ show success message in modal

    // ✅ Auto-close modal after 2 seconds
    setTimeout(() => {
      setShowModal(false);
      setIsVerified(false);
      setOtp(Array(6).fill(""));
    }, 2000);
  } else {
    alert(res?.message || "Invalid OTP");
  }
};

  // ✅ Calculate totals
  const total = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );
  const shipping = 10;
  const discount = 10;
  const grandTotal = total + shipping - discount;
 
  return (
    <div className="font-poppins">
      <div className="w-full">
        <Header />
      </div>
      <main className="flex gap-7 p-10 w-full min-h-screen bg-neutral-50 max-xl:flex-col max-xl:gap-5 max-md:p-5 max-sm:p-4">
        <section className="flex flex-col flex-1 gap-5 min-w-0">
          <div className="w-full">
            <Breadcrumb />
          </div>
 
          <div className="flex flex-col md:flex-row justify-between gap-6 p-6 bg-gray-50 min-h-screen">
            {/* Cart Items */}
           <div className="w-full md:w-2/3 bg-white rounded-xl shadow-md p-4">
  <h2 className="text-lg font-semibold mb-4 text-gray-900">Cart Items</h2>
  <div className="flex flex-col gap-4">
    {cartItems.map((item) => (
      <div
        key={item.id}
        className="border p-3 rounded-lg bg-white flex flex-col gap-3"
      >
        {/* Image + Name in one line */}
        <div className="flex items-center gap-3">
          <img
            src={item.img}
            alt={item.name}
            className="w-16 h-16 sm:w-20 sm:h-20 object-cover rounded-md"
          />
          <span className="font-medium text-gray-800 text-sm sm:text-base">
            {item.name}
          </span>
        </div>

        {/* Quantity controls in next line */}
        <div className="flex items-center gap-3">
          <button
            className="w-8 h-8 flex items-center justify-center rounded-full bg-[#002347] text-white hover:bg-gray-200 transition"
            onClick={() => decreaseQty(item.id)}
          >
            <FiMinus size={16} />
          </button>
          <span className="font-medium text-gray-800">{item.quantity}</span>
          <button
            className="w-8 h-8 flex items-center justify-center rounded-full bg-[#002347] text-white hover:bg-gray-200 transition"
            onClick={() => increaseQty(item.id)}
          >
            <FiPlus size={16} />
          </button>
        </div>
      </div>
    ))}
  </div>
</div>

 
            {/* Delivery Address + Order Summary */}
            <div className="w-full md:w-1/3 bg-white rounded-xl shadow-md p-4 flex flex-col gap-4">
              {/* Address Section */}
              <div className="bg-white shadow-md rounded-xl p-5">
                <h3 className="font-semibold mb-3 text-gray-900">Delivery Address</h3>
                <div className="flex items-center justify-between">
                  <p className="font-medium text-gray-800">Jaane Cooper</p>
                  <FiEdit2 className="text-gray-600 cursor-pointer hover:text-blue-600" />
                </div>
                <p className="text-sm text-gray-600">
                  4517 Washington Ave. Manchester,
                  <br />
                  Kentucky Preston Rd. Inglewood, 987456
                  <br />
                  +1 888 3685 368
                </p>
              </div>
 
              {/* Order Summary */}
              <div className="mt-4">
                <h2 className="text-lg font-semibold mb-2 text-gray-900">Order Summary</h2>
                <div className="flex justify-between text-gray-700">
                  <span>Premium toy charge</span>
                  <span>${total.toFixed(2)}</span>
                </div>
                <div className="flex justify-between text-gray-700">
                  <span>Shipping Charge</span>
                  <span>${shipping.toFixed(2)}</span>
                </div>
                <div className="flex justify-between text-red-500 font-medium">
                  <span>Discount (Premium toys)</span>
                  <span>-${discount.toFixed(2)}</span>
                </div>
                <hr className="my-2" />
                <div className="flex justify-between font-bold text-lg text-gray-900">
                  <span>Total</span>
                  <span>${grandTotal.toFixed(2)}</span>
                </div>
              </div>
 
              {/* Proceed Button */}
             <button
  onClick={() => {
    setShowPopup(true); // open subscription
    setShowModal(false); // close OTP modal if it’s open
  }}
  className="mt-4 w-full bg-green-500 text-white py-3 rounded-lg font-medium hover:bg-green-600 transition"
>
  Proceed & Pay
</button>

              <Subscription isOpen={showPopup} onClose={() => setShowPopup(false)} />
            </div>
          </div>
        </section>
      </main>
      <div className="w-full">
        <Footer />
      </div>
    </div>
  );
};
 
export default Cartpage;